import React from 'react';
import { useDispatch } from 'react-redux';
import {
    reInitialize,
    setShowRecommendation
} from '@om/redux/actions/investmentCalculator/investmentCalculator';

import OmButton from '../forms/OmButton';
import { OmCalculatorResultCard, OmIcon, OmOverlayOpener } from '@om/component-library-react';

const ResultCard = ({
    maxInvestmentValue,
    minInvestmentValue,
    sideIconName,
    maxValTitle,
    minValTitle,
    moreInfoBlockTitle,
    moreInfoBlockContent,
    moreInfoBlockContentBold,
    moreInfoBlockContentTwo,
    moreInfoBlockContentBoldTwo,
    moreInfoBlockButtonText,
    moreInfoBlockButtonIcon,
    isMobile,
    calculationResults
}) => {

    const dispatch = useDispatch();

    const setViewRecommendation = () => {
        dispatch(setShowRecommendation())
    }

    return (
        <div className="result-desktop-modal">
            {
                isMobile
                    ? <OmCalculatorResultCard
                        currency={'KES'}
                        isMobile={true}
                        mainPaymentValue={maxInvestmentValue}
                        secondaryPaymentValue={minInvestmentValue}
                        sideIconName={sideIconName}
                        mainPaymentTitle={maxValTitle}
                        secondaryPaymentTitle={minValTitle}
                        moreInfoBlockTitle={moreInfoBlockTitle}
                        moreInfoBlockContent={moreInfoBlockContent}
                        moreInfoBlockContentBold={moreInfoBlockContentBold}
                        moreInfoBlockContentTwo={moreInfoBlockContentTwo}
                        moreInfoBlockContentBoldTwo={moreInfoBlockContentBoldTwo}
                    >
                        <OmOverlayOpener
                            slot="help-outline-mobile"
                            openingOverlay="field-details"
                        >
                        </OmOverlayOpener>
                        <OmIcon
                            slot="side-icon"
                            iconName={sideIconName}
                        />
                        <span slot={'result-message'} dangerouslySetInnerHTML={{__html: calculationResults || ''}}></span>
                        <OmButton
                            slot="recalculate-mobile"
                            type="secondary"
                            size="small"
                            text="RECALCULATE"
                            onClick={() => dispatch(reInitialize())}
                        />
                        <OmButton
                            slot="tell-me-more-mobile"
                            type="primary"
                            size="small"
                            text={moreInfoBlockButtonText}
                            withIcon={true}
                            iconName={moreInfoBlockButtonIcon}
                            onClick={() => setViewRecommendation()}
                        />
                    </OmCalculatorResultCard>
                    : <OmCalculatorResultCard
                        currency={'KES'}
                        isMobile={false}
                        mainPaymentValue={maxInvestmentValue}
                        secondaryPaymentValue={minInvestmentValue}
                        sideIconName={sideIconName}
                        mainPaymentTitle={maxValTitle}
                        secondaryPaymentTitle={minValTitle}
                        moreInfoBlockTitle={moreInfoBlockTitle}
                        moreInfoBlockContentBold={moreInfoBlockContentBold}
                        moreInfoBlockContentTwo={moreInfoBlockContentTwo}
                        moreInfoBlockContentBoldTwo={moreInfoBlockContentBoldTwo}
                    >
                        <OmIcon
                            slot="side-icon"
                            iconName={sideIconName}
                        />
                        <OmButton
                            slot="recalculate"
                            type="secondary"
                            size="small"
                            text="RECALCULATE"
                            onClick={() => dispatch(reInitialize())}
                        />
                        <span slot={'result-message'} dangerouslySetInnerHTML={{__html: calculationResults}}></span>
                        <OmButton
                            slot="tell-me-more"
                            type="primary"
                            size="small"
                            text={moreInfoBlockButtonText}
                            withIcon={true}
                            iconName={moreInfoBlockButtonIcon}
                            onClick={() => setViewRecommendation()}
                        />
                    </OmCalculatorResultCard>
            }

        </div>
    )
}

export default ResultCard;
